module.exports = __webpack_public_path__ + "static/media/bg.597dbf8f.jpg";